import { render, staticRenderFns } from "./DocumentUploadSection.vue?vue&type=template&id=3b8d407c&scoped=true&"
import script from "./DocumentUploadSection.vue?vue&type=script&lang=js&"
export * from "./DocumentUploadSection.vue?vue&type=script&lang=js&"
import style0 from "./DocumentUploadSection.vue?vue&type=style&index=0&id=3b8d407c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8d407c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\11\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b8d407c')) {
      api.createRecord('3b8d407c', component.options)
    } else {
      api.reload('3b8d407c', component.options)
    }
    module.hot.accept("./DocumentUploadSection.vue?vue&type=template&id=3b8d407c&scoped=true&", function () {
      api.rerender('3b8d407c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business-orders/DocumentUploadSection.vue"
export default component.exports